<template>
  <div class="button-container">
    <div v-if="alignments.length === 0" class="show-alignments-button-filler"></div>
    <!-- eslint-disable-next-line vue-i18n/no-raw-text -->
    <div class="show-alignments-button" v-else :title="workTitle" :class="{ selected }" @click.prevent="onToggleShow">
      <template v-if="alignments.length > 1">
        <span
          class="dot"
          v-for="alignment in alignments"
          :key="alignment.id" />
      </template>
    </div>
  </div>
</template>

<script>
  import { SELECT_ALIGNMENT, CLEAR_ALIGNMENT } from '../../constants';

  export default {
    props: ['line', 'alignments'],
    computed: {
      workTitle() {
        const workCounts = {};
        this.alignments.forEach((alignment) => {
          workCounts[alignment.rightWork.name] = 1 + (workCounts[alignment.rightWork.name] || 0);
        });
        return Object.keys(workCounts)
          .map(work => (workCounts[work] > 1 ? `${work} (${workCounts[work]})` : work))
          .join(', ');
      },
      selected() {
        const [s1, e1] = this.selectedBoundaries;
        return this.line.idx >= s1 && this.line.idx <= e1;
      },
      selectedBoundaries() {
        const left = Math.min(...(this.$store.state.selectedAlignments || []).map(a => a.leftBoundary[0][0]));
        const right = Math.max(...(this.$store.state.selectedAlignments || []).map(a => a.leftBoundary[1][0]));
        return [left, right];
      },
    },
    methods: {
      onToggleShow() {
        if (this.selected) {
          this.$store.dispatch(CLEAR_ALIGNMENT);
        } else {
          this.$store.dispatch(SELECT_ALIGNMENT, { alignments: this.alignments });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../variables.scss";

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .show-alignments-button,
  .show-alignments-button-filler {
    width: 10px;
    flex: 1;
  }

  .dot {
    display: block;
    background-color: $white;
    height: 4px;
    width: 4px;
    margin: 6px auto;
    border-radius: 10px;
  }

  .show-alignments-button {
    cursor: pointer;
    background: $text-reuse-background;
    &:hover {
      background: lighten($text-reuse-background, 10);
    }
    &.selected {
      background: darken($text-reuse-background, 10);
    }
  }
</style>
